import axios from '@/utils/axios'

export const getBill = (payload) => {
    return axios.get('/bill', {
        params: payload
    })
}

export const createBill = (data) => {
    return axios.post('/bill', data)
}

export const updateBill = (id, data) => {
    return axios.put(`/bill/${id}`, data)
}

export const deleteBill = (id) => {
    return axios.delete(`/bill/${id}`)
}